import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import SignInWithOtp from "@/components/auth/signin-with-otp";
import { GoogleAuthButton } from "@/components/auth/google-auth-button";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";
import { isLocalInstallEdition } from "@/lib/edition/edition";

/**
 * Registro abierto en la nube: Google o correo con código (el mismo código
 * confirma el correo y crea la cuenta si no existe). Al entrar, el usuario sin
 * empresa ve el alta rápida (components/onboarding/quick-onboarding.tsx) y su
 * empresa queda en prueba. Las instalaciones locales no tienen registro: las
 * cuentas las crea el admin.
 */
export const Route = createFileRoute("/_public/auth/sign-up")({
  component: SignUpPage,
});

function SignUpPage() {
  const navigate = useNavigate();
  const emailEnabled = useQuery(
    api.system.onboarding.queries.isPasswordResetEmailEnabled,
  );

  useEffect(() => {
    if (isLocalInstallEdition()) navigate({ to: "/auth/sign-in", replace: true });
  }, [navigate]);

  if (isLocalInstallEdition()) return null;

  return (
    <div className="relative min-h-screen">
      <AuthLeftPanel
        headline="Empieza gratis. Construye lo que necesitas."
        subtitle="30 días de prueba con todo incluido, sin tarjeta. Empieza con una app de la tienda o desde cero, y al terminar eliges un plan."
        badge="Prueba de 30 días"
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        {emailEnabled !== false && (
          <SignInWithOtp provider="resend-otp" mode="signUp" />
        )}

        <div className="mt-4">
          <GoogleAuthButton />
        </div>

        <p className="mt-6 text-center text-sm text-muted-foreground">
          ¿Ya tienes cuenta?{" "}
          <Link to="/auth/sign-in" className="font-medium text-primary hover:underline">
            Inicia sesión
          </Link>
        </p>
      </AuthRightPanel>
    </div>
  );
}
